module.exports = __webpack_public_path__ + "img/img_qrcode_kefu@2x.716b2d8e.png";